<template>
  <b-sidebar id="main-sidebar" :title="title" backdrop>
    <template>
      <Profile />
    </template>

    <hr />
    <b-nav vertical class="py-1 px-1">
      <div v-for="(value, name) in treeSidebar" :key="name">
        <strong class="sidebar-header">{{ name }}</strong>
        <div v-for="(route, index) in value" :key="index">
          <RouteCard :route="route" />
        </div>
        <hr />
      </div>

      <div v-if="isFakeAuth">
        <RouteCard :route="routeExit" />
        <hr />
      </div>
      <div class="mt-1">
        <RouteCard :route="routeDep" :popoverHelp="routeDep.popoverHelp" />
      </div>
      <div class="mt-1">
        <RouteCard :route="routeOrg" :popoverHelp="routeOrg.popoverHelp" />
      </div>
      <div class="mt-1">
        <RouteCard
          :route="routeSupport"
          :popoverHelp="routeSupport.popoverHelp"
        />
      </div>
    </b-nav>
  </b-sidebar>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import Profile from '@/components/pages/home/components/sidebar/components/Profile.vue'
import { routes } from '@/router'
import { RouteConfig, RouteConfigSingleView } from 'vue-router/types/router'
import Config from '@/config/config'
import { PermissionPageManager } from '@/api/permissions/pages'
import { permissions } from '@/api/permissions/permissions'
import { supportEmail, wikiPage, orgEmail, depEmail } from '@/config/urls'
import RouteCard from '@/components/pages/home/components/sidebar/components/RouteCard.vue'
import FakeUserAPI from '@/components/routes/admin/fake/helpers/requests'
import { userMappers } from '@/store/modules/user'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters(['isFakeAuth']),
  },
})

@Component({ components: { RouteCard, Profile } })
export default class Sidebar extends Mappers {
  private treeSidebar: { [k: string]: RouteConfigSingleView[] } = {}
  private title = Config.systemTitle.shortName

  private routeSupport = {
    meta: {
      icon: ['fas', 'envelope'],
      displayName:
        `<div>Тех. вопросы: <a href="mailto:${supportEmail}" target="_blank">${supportEmail}</a></div>` +
        `<div><a href="${wikiPage(
          'supportrules'
        )}">Правила написания</a></div>`,
    },
    popoverHelp: {
      id: 'targetSupport',
      title: 'Технические вопросы',
      text: `По техническим вопросам и ошибкам пишите на почту ${supportEmail}`,
    },
  }
  private routeExit = {
    click: this.onLogout,
    meta: {
      icon: ['fas', 'sign-out-alt'],
      displayName: 'Выйти из режима просмотра',
    },
  }

  private routeOrg = {
    meta: {
      icon: ['fas', 'print'],
      displayName: `<div>Поддержка ДПО: <a href="mailto:${orgEmail}" target="_blank">${orgEmail}</a></div><div></div>`,
    },
    popoverHelp: {
      id: 'targetOffice',
      title: 'Поддержка ДПО',
      text: `По организационным вопросам, вопросам обработки и отклонения заявок, не связанным с Цифровой кафедрой, пишите на почту ${orgEmail}`,
      style: 'width: 205px;',
    },
  }

  private routeDep = {
    meta: {
      icon: ['fas', 'print'],
      displayName: `<div>Поддержка ЦК: <a href="mailto:${depEmail}" target="_blank">${depEmail}</a></div><div></div>`,
    },
    popoverHelp: {
      id: 'targetDep',
      title: 'Поддержка ЦК',
      text: `По вопросам, связанным с Цифровой кафедрой, пишите на почту ${depEmail}`,
      style: 'width: 205px;',
    },
  }

  private created() {
    const routerPages: RouteConfig[] | undefined = routes[0].children
    const abilities = PermissionPageManager.sidebar()
    this.treeSidebar = {}

    if (routerPages) {
      for (const route of routerPages) {
        if (
          abilities.can(permissions.viewPage, route.name) &&
          route.meta?.isDisplayInSidebar
        ) {
          const group = route.meta.group

          if (group in this.treeSidebar) {
            this.treeSidebar[group].push(route)
          } else {
            this.treeSidebar[group] = [route]
          }
        }
      }
    }
  }

  private onLogout() {
    FakeUserAPI.fakeUserLogout()
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.sidebar-header {
  padding: 0 1rem;
}
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
